<template>
  <CDropdown>
    <!-- Modal -->
    <CModal size="lg" :visible="showModals.setting" @close="() => {showModals.setting = false}">
      <CModalHeader>
        <CModalTitle><CIcon icon="cil-settings" /> User Setting</CModalTitle>
      </CModalHeader>
      <CModalBody>
        User Setting
      </CModalBody>
    </CModal>
    <!-- End Modal -->
    <CDropdownToggle placement="bottom-end" class="py-0 d-flex align-items-center topbar-avatar" :caret="false">
      <div class="d-inline-block p-0 m-0 px-2 text-right">
        <p class="p-0 m-0 text-theme-dark">{{ $helpers.getUserInfo().name }}</p>
        <p class="p-0 m-0 text-theme-white">{{ $helpers.getUserInfo().role_name }}</p>
      </div>
      <div class="number-circle-wrapper-xxl bg-image shadow bg-theme-dark" :style="`background-image: url(${''})`">
        <CIcon icon="cil-user" class="text-white" />
      </div>
    </CDropdownToggle>
    <CDropdownMenu class="py-0 theme-rounded-md border-0 shadow">
      <CDropdownItem class="theme-rounded-md cursor-pointer py-2" @click="() => { showModals.setting = true }"> <CIcon icon="cil-settings" /> Settings</CDropdownItem>
      <CDropdownItem @click="logOut()" class="cursor-pointer text-theme-danger hovered-item-danger theme-rounded-md py-2"> <CIcon icon="cil-lock-locked" /> Logout </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
export default {
  name: 'AppHeaderDropdownAccnt',
  data() {
    return {
      showModals: {
        setting: false
      }
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout')
      this.$router.push("/login")
    }
  }
}
</script>
